import React, { useEffect, useState } from "react";
import { fetchFileBlobUrl } from "../api/fileApi";
import "./PhotoUpload.css";

/**
 * Shows the current photo (fetched as an authenticated blob — see fileApi
 * javadoc for why a plain `<img src="/api/files/...">` can't work) and lets
 * the user pick a replacement, uploading immediately via `onUpload`.
 */
export default function PhotoUpload({ folder, fileName, onUpload, disabled }) {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let objectUrl;
    let cancelled = false;

    if (fileName) {
      fetchFileBlobUrl(folder, fileName)
        .then((url) => {
          if (!cancelled) {
            objectUrl = url;
            setPreviewUrl(url);
          }
        })
        .catch(() => {
          if (!cancelled) {
            setPreviewUrl(null);
          }
        });
    } else {
      setPreviewUrl(null);
    }

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [folder, fileName]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    setError("");
    setUploading(true);
    try {
      await onUpload(file);
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to upload photo.");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="photo-upload">
      <div className="photo-upload-preview">
        {previewUrl ? <img src={previewUrl} alt="" /> : <span className="photo-upload-placeholder">No photo</span>}
      </div>
      <label className="photo-upload-button">
        {uploading ? "Uploading..." : "Change Photo"}
        <input type="file" accept="image/jpeg,image/jpg,image/png" onChange={handleFileChange} disabled={disabled || uploading} />
      </label>
      {error && <div className="photo-upload-error">{error}</div>}
    </div>
  );
}
